// extracted by mini-css-extract-plugin
module.exports = {"safe":"getOfferSafety_safe__O_IPl","hide":"getOfferSafety_hide__y4cmU"};